import { accounts } from "../icons";
import { files } from "../icons";
import { reports } from "../icons";
import { itAssets } from "../icons";
import { hrSelfService } from "../icons";
import { payroll } from "../icons";
import { leaveTracker } from "../icons";
import { announcements } from "../icons";
import { yammer } from "../icons";
import { sharepoint } from "../icons";
import { oneDrive } from "../icons";
import { outlook } from "../icons";
import { teams } from "../icons";
import { vHire } from "../icons";
import { vPerform } from "../icons";
import { vTravel } from "../icons";
import { vExpense } from "../icons";
import { vReward } from "../icons";
import { vFlourish } from "../icons";
import { vTrackLogo } from "../icons";
import { vChat, vAgentHub, whiteVChat, whiteVAgentHub } from "../icons";
import { vLoopIn } from "../icons";
import { whiteAccounts } from "../icons";
import { whiteFiles } from "../icons";
import { whiteReports } from "../icons";
import { whiteItAssets } from "../icons";
import { whiteHrSelfService } from "../icons";
import { whitePayroll } from "../icons";
import { whiteLeaveTracker } from "../icons";
import { whiteAnnouncements } from "../icons";
import { whiteYammer } from "../icons";
import { whiteSharepoint } from "../icons";
import { whiteOneDrive } from "../icons";
import { whiteOutlook } from "../icons";
import { whiteTeams } from "../icons";
import { whiteVHire } from "../icons";
import { whiteVPerform } from "../icons";
import { whiteVTravel } from "../icons";
import { whiteVExpense } from "../icons";
import { whiteVReward } from "../icons";
import { whiteVFlourish } from "../icons";
import { whiteVTrackLogo } from "../icons";
import { whiteVLoopIn } from "../icons";
//import {getRefreshTokenSecret} from "../../config/authConfig";

const secret = null

export const vTools = [
  {
    name: "Track",
    image: vTrackLogo,
    color: "#1773BC",
    hoveredImg: whiteVTrackLogo,
    link: "/vTrack",
  },
  {
    name: "Veersa Agent Hub",
    noVPrefix: true,
    image: vAgentHub,
    hoveredImg: whiteVAgentHub,
    link: "https://ai.veersalabs.com/agent-hub/",
  },
  {
    name: "GPT 2.0",
    image: vChat,
    hoveredImg: whiteVChat,
    link: "https://ai.veersalabs.com/veersa-GPT/vGPT2",
  },
  // {
  //   name: "SessionReporting",
  //   image: reports,
  //   color: "#1773BC",
  //   hoveredImg: whiteReports,
  //   link: "/session-reporting",
  // },
  // {
  //   name: "Resource Dashboard",
  //   image: reports,
  //   color: "#1773BC",
  //   hoveredImg: whiteReports,
  //   link: "/resource-dashboard",
  // },
  {
    name: "Loop In",
    image: vLoopIn,
    hoveredImg: whiteVLoopIn,
    link: "https://loopin.veersatech.com/employee-dashboard",
  },
  {
    name: "Reward",
    image: vReward,
    hoveredImg: whiteVReward,
    link: "https://people.zoho.in/veersa/zp#rewards_and_recognition/form/listview-formId:54780000000314335/viewId:54780000000314337",
  },
  {
    name: "Expense",
    image: vExpense,
    hoveredImg: whiteVExpense,
    link: "https://people.zoho.in/veersa/zp#expense_reimbursement/form/listview-formId:54780000001607013/viewId:54780000001607015",
  },
  {
    name: "Travel",
    image: vTravel,
    hoveredImg: whiteVTravel,
    link: "https://people.zoho.in/veersa/zp#travel/form/listview-formId:54780000000035731/viewId:54780000000035733",
  },
  {
    name: "Perform",
    image: vPerform,
    hoveredImg: whiteVPerform,
    link: `https://vperform.veersatech.com/launch?refreshToken=${secret}`,
  },
  {
    name: "Hire",
    image: vHire,
    hoveredImg: whiteVHire,
    link: "https://dev.azure.com/Veersa/Hiring",
  },
  {
    name: "People Assist",
    image: vChat,
    hoveredImg: whiteVChat,
    link: "https://ai.veersalabs.com/veersa-GPT/gpt/vPeople%20Assist",
  },
];

export const collabtools = [
  {
    name: "Teams",
    image: teams,
    hoveredImg: whiteTeams,
    link: "https://teams.microsoft.com",
  },
  {
    name: "Outlook",
    image: outlook,
    hoveredImg: whiteOutlook,
    link: "https://outlook.office.com/mail/",
  },
  {
    name: "OneDrive",
    image: oneDrive,
    hoveredImg: whiteOneDrive,
    link: "https://veersalabs-my.sharepoint.com/",
  },
  {
    name: "Sharepoint",
    image: sharepoint,
    hoveredImg: whiteSharepoint,
    link: "https://veersalabs.sharepoint.com/",
  },
  {
    name: "Yammer",
    image: yammer,
    hoveredImg: whiteYammer,
    link: "https://web.yammer.com/main/org/veersatech.com/feed",
  },
];

export const service = [
  {
    name: "Announcemnts",
    image: announcements,
    hoveredImg: whiteAnnouncements,
    link: "https://people.zoho.in/veersa/zp#announcements/list",
  },
  {
    name: "Leave Tracker",
    image: leaveTracker,
    hoveredImg: whiteLeaveTracker,
    link: "https://people.zoho.in/veersa/zp#leavetracker/views/list",
  },
  {
    name: "Payroll",
    image: payroll,
    hoveredImg: whitePayroll,
    link: "https://payroll.zoho.in/",
  },
  {
    name: "Hr Self service",
    image: hrSelfService,
    hoveredImg: whiteHrSelfService,
    link: "https://people.zoho.in/veersa/zp#selfservice/user/profile",
  },
  {
    name: "IT Assets",
    image: itAssets,
    hoveredImg: whiteItAssets,
    link: "https://people.zoho.in/veersa/zp#it_assets_inventory/form/listview-formId:54780000000035743/viewId:54780000000035745",
  },
  {
    name: "Reports",
    image: reports,
    hoveredImg: whiteReports,
    link: "https://people.zoho.in/veersa/zp#reports/home",
  },
  {
    name: "Accounts",
    image: accounts,
    hoveredImg: whiteAccounts,
    link: "/",
  },
  {
    name: "Files",
    image: files,
    hoveredImg: whiteFiles,
    link: "https://people.zoho.in/veersa/zp#files/companyfile/listview",
  },
];
